import script from "./Transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=1c95e6ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c95e6ba"]])

export default __exports__